import React from "react";
import { connect } from "react-redux";
import withLocalization from "../../../hoc/with-localization";
import { _param_edited } from "../../../redux/actions/actionConstants";

class MedicalConclusion extends React.Component {
    render() {
        const { reportData, loc, openDialog, popupable } = this.props;
        if (!reportData) {
            return null;
        }

        const { medicalConclusion } = reportData.report;
        const { useExternalConclusionConstructor } = reportData.settings;
        if (!medicalConclusion) {
            return null;
        }

        const { val: content, state } = medicalConclusion;
        const edited = state === _param_edited;
        const caption =
            edited || useExternalConclusionConstructor ? loc("report.captions.conclusion") : loc("report.captions.autoConclusion");
        return (
            <div className="medical-report__section">
                <div className={popupable ? "popup-able" : ""}>
                    {popupable ? (
                        <button className="popup-open-btn" data-popup-window="MedRep-popup-window" onClick={openDialog}>
                            {" "}
                            {"\ue800"}
                        </button>
                    ) : null}
                    <div className="medical-conslusion">
                        <h3 className="medical-conclusion__header">{caption}</h3>
                        <div className="medical-report__content" dangerouslySetInnerHTML={{ __html: content }}></div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ reportApp: { reportData } }) => {
    return {
        reportData
    };
};
export default connect(mapStateToProps)(withLocalization(MedicalConclusion));
